var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 40,
    height: 39,
    viewBox: "0 0 1.37 1.35",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.39 1.01c.02.13.01.16.02.26.05-.07.15-.16.21-.22.05 0 .12.05.3.01.42-.09.53-.74.08-.92C.74.04.32.07.19.31c-.32.6.2.69.2.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17,
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })));
};

export default SvgMessage;